// removed by extract-text-webpack-plugin
module.exports = {"root":"load-more-button__root","isLoading":"load-more-button__isLoading","loadingSpinner":"load-more-button__loadingSpinner","spin":"load-more-button__spin","spinAfter":"load-more-button__spinAfter"};


//////////////////
// WEBPACK FOOTER
// ./src/show-page/components/load-more-button/styles.less
// module id = 491
// module chunks = 1